<ng-template #mymodal let-modal>
  <div class="modal-header">
    <h4
      class="text-lg leading-6 font-medium text-gray-900"
      id="modal-basic-title"
    >
      Confirm email
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <div
        class="
          mx-auto
          flex
          items-center
          justify-center
          h-12
          w-12
          rounded-full
          bg-green-100
        "
      >
        <svg
          class="h-5 w-5 text-green-600"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
          />
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <form [formGroup]="memberEmailForm">
          <div class="my-5 relative">
            <input
              type="text"
              name="email"
              formControlName="memberEmail"
              id="email"
              class="block border-0 border-b w-full text-center text-gray-500"
              placeholder=""
            />
          </div>
          <p
            class="text-sm text-red-600"
            *ngIf="memberEmailForm.controls.memberEmail.errors?.pattern"
          >
          {{ constants.invalidEmailError }}
          </p>
        </form>
      </div>
      <div *ngIf="isEmailSuccessful" class="mt-3 text-center sm:mt-5">
        <p class="text-sm text-green-600">{{ constants.sendEmailSuccess }}</p>
      </div>
      <div *ngIf="isErrorSendingEmail" class="mt-3 text-center sm:mt-5">
        <p *ngIf="!isCompassUserError" class="text-sm text-red-600">
          {{ constants.emailPdfErrorMessageRetry }}
        </p>
        <p *ngIf="isCompassUserError" class="text-sm text-red-600">
          {{ compassUserErrorMessage }}
        </p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="mt-5 flex flex-wrap">
      <div class="flex">
        <button
          type="button"
          (click)="modal.close('Cancel click')"
          class="
            flex
            w-full
            uppercase
            inline-flex
            justify-center
            rounded-md
            border border-orange-forbes
            shadow-sm
            px-4
            py-2
            bg-white
            text-base
            font-light
            text-gray-700
            focus:outline-none
            focus:ring-2
            focus:ring-offset-2
            focus:ring-orange-forbes
            sm:mt-0 sm:col-start-1 sm:text-sm
          "
        >
          close
        </button>
      </div>
      <div class="flex px-6">
        <button
          type="button"
          (click)="sendEAC()"
          [disabled]="memberEmailForm.controls.memberEmail.errors?.pattern"
          class="
            flex
            w-full
            uppercase
            inline-flex
            justify-center
            rounded-md
            border border-transparent
            disabled:cursor-not-allowed
            shadow-sm
            px-4
            py-2
            bg-orange-forbes
            text-base
            font-light
            text-white
            focus:outline-none
            focus:ring-2
            focus:ring-offset-2
            focus:ring-orange-forbes
            sm:col-start-2 sm:text-sm
          "
        >
          send
        </button>
      </div>
    </div>
  </div>
</ng-template>

<div class="px-28 pb-10 my-10">
  <div class="flex flex-wrap justify-between -mx-4 items-center my-10">
    <div class="flex items-center px-6">
      <label for="title" class="block text-sm font-medium text-gray-700"
        >Title</label
      >
      <div class="px-2">
        <input
          type="text"
          name="title"
          [(ngModel)]="memberDetails!.Title"
          id="title"
          class="
            block
            sm:text-sm
            border-b-1
            bg-gray-100
            border-t-0 border-l-0 border-r-0
            text-sm
            font-extralight
            text-gray-400
            pl-0
          "
          placeholder=""
          readonly
        />
      </div>
    </div>
    <div class="flex items-center px-6">
      <label for="firstName" class="block text-sm font-medium text-gray-700"
        >First Name</label
      >
      <div class="px-2">
        <input
          type="text"
          name="firstName"
          [(ngModel)]="memberDetails!.FirstName"
          id="firstName"
          class="
            block
            sm:text-sm
            border-b-1
            bg-gray-100
            border-t-0 border-l-0 border-r-0
            text-sm
            font-extralight
            text-gray-400
            pl-0
          "
          placeholder=""
          readonly
        />
      </div>
    </div>
    <div class="flex flex-1 items-center px-6">
      <label for="lastName" class="block text-sm font-medium text-gray-700"
        >Last Name</label
      >
      <div class="px-2">
        <input
          type="text"
          name="lastName"
          id="lastName"
          [(ngModel)]="memberDetails!.Surname"
          class="
            block
            sm:text-sm
            border-b-1
            bg-gray-100
            border-t-0 border-l-0 border-r-0
            text-sm
            font-extralight
            text-gray-400
            pl-0
          "
          placeholder=""
          readonly
        />
      </div>
    </div>
    <div class="flex items-center px-6">
      <div>
        <button
          (click)="viewProductInfo()"
          class="
            uppercase
            bg-orange-forbes
            p-2
            font-light
            text-sm
            rounded-md
            text-white
            w-40
            h-14
          "
        >
          cancel
        </button>
      </div>
    </div>
  </div>
  <div
    class="
      w-full
      shadow-md
      flex
      justify-between
      bg-white
      mt-10
      px-20
      pt-10
      pb-5
    "
  >
    <div>
      <p class="font-extralight text-sm mb-3">Name</p>
      <p class="text-orange-forbes">{{ selectedProduct.Participant }}</p>
    </div>
    <div>
      <p class="font-extralight text-sm mb-3">Fund Credit</p>
      <p class="text-orange-forbes">{{ selectedProduct.FundCredit }}</p>
    </div>
  </div>

  <div class="mt-10 text-sm mb-10">
    <p class="mb-2">
      Effective Annual Cost: <strong>{{ selectedProduct.Participant }} </strong> - as on <strong> {{ todaysDate }} </strong>
    </p>
    <p class="border-orange-forbes border-t"></p>
  </div>

  <!-- EAC Table  -->

  <div class="flex flex-col mb-8">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div
          *ngIf="showPdfViewer && isLoadingPdf"
          class="
            bg-white
            border-2 border-orange-forbes
            overflow-hidden
            p-6
            shadow
            sm:rounded-lg
            text-center
          "
        >
          <p>Loading PDF...</p>
        </div>
        <div
          *ngIf="showPdfViewer && !isErrorFetchingPDF && isPdfLoaded"
          class="
            bg-white
            border-2 border-orange-forbes
            overflow-hidden
            p-6
            shadow
            sm:rounded-lg
          "
        >
          <app-pdf-viewer [pdfSrc]="pdfSourcePath"></app-pdf-viewer>
        </div>
        <div *ngIf="showPdfViewer && isErrorFetchingPDF" class="fixed top-0 left-0 right-0 z-50 p-4">
          <div class="max-w-4xl mx-auto">
            <div class="
              bg-red-50 
              border 
              border-red-200 
              rounded-lg 
              p-4 
              shadow-lg
              flex 
              items-center 
              justify-between
            ">
              <div class="flex items-center">
                <svg class="w-6 h-6 text-red-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                </svg>
                <div>
                  <h3 class="text-sm font-medium text-red-800">Unable to Download Statement</h3>
                  <p *ngIf="!isCompassUserError" class="text-sm text-red-700 mt-1">
                    An error occurred while downloading the statement. Please try again later.
                  </p>
                  <p *ngIf="isCompassUserError" class="text-sm text-red-700 mt-1">
                    {{ compassUserErrorMessage }}
                  </p>
                </div>
              </div>
              <button
                (click)="closePdfError()"
                class="
                  inline-flex 
                  items-center 
                  p-1.5 
                  text-red-400 
                  hover:text-red-600 
                  transition-colors 
                  duration-200
                "
                aria-label="Close"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex items-center justify-between my-2 uppercase">
    <div>
      <button
        (click)="showEmailPopUp(mymodal)"
        class="
          uppercase
          bg-orange-forbes
          p-2
          font-light
          text-sm
          rounded-md
          text-white
          w-40
          h-14
        "
      >
        email eac
      </button>
    </div>
    <div>
      <button
        (click)="togglePdfViewer()"
        class="
          uppercase
          bg-orange-forbes
          p-2
          font-light
          text-sm
          rounded-md
          text-white
          w-40
          h-14
        "
      >
        View Statement
      </button>
    </div>
    <div>
      <button
        (click)="toggleDisclaimer()"
        class="
          uppercase
          bg-orange-forbes
          p-2
          font-light
          text-sm
          rounded-md
          text-white
          w-40
          h-14
        "
      >
        View Disclosure
      </button>
    </div>
  </div>

  <div *ngIf="showDisclaimer" class="font-thin text-gray-700 text-sm space-y-5">
    <p class="font-medium mt-6 font text-gray-900">Notes:</p>
    <p>
      ‘Other’ charges cover any remaining charges that you may incur. However,
      Alexander Forbes does not currently levy any ‘Other’ charges.
    </p>
    <p>
      Term to maturity is assumed to be the end of investment term, according to
      regulatory guidelines.
    </p>
    <p>
      Investment management charge excludes the weighted average rebate
      (platform fee) received from investment manager/s, which is not passed on
      to the investor. This is included in the administration charge.
    </p>
    <p>
      The administration charge may change on your appointing, ceasing to have
      or changing a financial adviser, and may also change should you change how
      your investment is allocated to investment portfolios.
    </p>
    <p>
      Initial advice charges are spread over the period for which the investment
      is held. So where an initial advice charge is levied, the EAC will be
      higher for shorter periods of holding the investment *indicates where
      product aggregation has been applied.
    </p>
    <p>
      *Clients invested in a select range of investment portfolios, through FPC,
      will receive a further discount of 25% on their administration fee in
      proportion to the percentage of assets under administration in these
      portfolios. These investment portfolios are not available on all products.
      At the discretion of the board of trustees, portfolios and funds may be
      added to or removed from the selected range of discounted portfolios. In
      addition, the percentage discount may be reduced, increased or removed
      from any of the funds in the select range of portfolios.
    </p>
    <p>
      All calculations include value-added tax (VAT) at the current rate, where
      applicable.
    </p>
    <p>
      Where necessary, amounts have been rounded to the nearest one decimal
      place.
    </p>
    <p>
      If the services of FPC are terminated and replaced by the services of
      another servicing intermediary, or the client becomes a direct client of
      AFICA:
    </p>
    <p>
      standard administration fees will apply to the product, from the month
      following the date of termination or change in servicing intermediary
    </p>
    the additional selected investment portfolio discount will also terminate on
    the same date.
  </div>
</div>
